// tslint:disable-next-line:max-classes-per-file
export class ApplicationError extends Error {

    public Type: ExceptionType;

    constructor(message = "An unknown error occurred") {
        super(message);
    }
}

// tslint:disable-next-line:max-classes-per-file
export class IpAuthenticationError extends ApplicationError {

    public Type = ExceptionType.IpAuthenticationError;

    constructor(message = "Your organisation has IP recognition enabled, but no access to this product") {
        super(message);
    }
}

export class UrlCredentialsAuthenticationError extends ApplicationError {

    public Type = ExceptionType.UrlCredentialsAuthenticationError;

    constructor(message = "Automatic login failed") {
        super(message);
    }
}

// tslint:disable-next-line:max-classes-per-file
export class NetworkError extends ApplicationError {

    public Type = ExceptionType.NetworkError;

    constructor(message = "Unable to connect to server") {
        super(message);
    }
}

export enum ExceptionType {
    IpAuthenticationError,
    UrlCredentialsAuthenticationError,
    NetworkError,
    Unknown
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/authentication/exceptions.ts